import { AgCheckBoxCellRendererComponent } from 'components/AgGrid/AgCheckBoxCellRendererComponent';
import { AgCheckBoxHeaderComponent } from 'components/AgGrid/AgCheckBoxHederComponent';
import { AgGridCellTooltipComponent, AgGridCellTooltipValueGetter } from 'components/AgGrid/AgGridCellTooltipComponent';
import { numberFormatter, suppressKeyboardEventForInput } from 'components/AgGrid/utils';
import type { GroupCollapseState } from 'pages/Project/UerProject/ActKC3List/components/ActKC3ListTable/types';
import type { IContractOtherCostLimitSpanSelectionItem } from 'pages/Project/UerProject/Contract/hooks/useUerContractOtherCostLimitSpanSelectionList';

import type { ColDef } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

import { CostCellRendererComponent } from '../components/CostCellRendererComponent';
import { NameCellRendererComponent } from '../components/NameCellRendererComponent';

interface IUseUerContractOtherCostLimitSpanSelectionListColumns {
    allIds: string[];
    checkedIds: string[];
    onCheckChange: (checkedIds: string[]) => void;
    onChange?: (id: string, value: number | null, parentKey?: string) => void;
    changeCollapseState: (groupKey: string) => () => void;
    collapseState: GroupCollapseState;
}

const cellClass = (cellClassParams: any) => (cellClassParams?.data?.isTotal ? 'total-row' : undefined);

export const useUerContractOtherCostLimitSpanSelectionListColumns = (
    props: IUseUerContractOtherCostLimitSpanSelectionListColumns,
) => {
    const { allIds, checkedIds, onCheckChange, onChange, changeCollapseState, collapseState } = props;

    const noCheckboxChecker = useCallback(
        (data: IContractOtherCostLimitSpanSelectionItem) => data.isTotal || data.isGroupMember,
        [],
    );

    return useMemo<ColDef<IContractOtherCostLimitSpanSelectionItem>[]>(
        () => [
            {
                field: 'checkbox' as any,
                width: 60,
                resizable: false,
                cellRenderer: AgCheckBoxCellRendererComponent,
                cellRendererParams: {
                    checkedIds,
                    onCheckChange,
                    noCheckboxChecker,
                },
                headerComponent: AgCheckBoxHeaderComponent,
                headerComponentParams: {
                    checkedIds,
                    allIds,
                    onCheckChange,
                },
                cellClass,
            },
            {
                field: 'name',
                headerName: 'Статьи затрат',
                cellRenderer: NameCellRendererComponent,
                cellRendererParams: {
                    changeCollapseState,
                    collapseState,
                },
                tooltipComponent: AgGridCellTooltipComponent,
                tooltipValueGetter: AgGridCellTooltipValueGetter({}),
                flex: 1,
                cellClass,
            },
            {
                field: 'plan',
                headerName: 'План по договору',
                width: 200,
                valueFormatter: numberFormatter(2),
                cellClass,
            },
            {
                field: 'actual',
                headerName: 'Факт по договору',
                width: 200,
                valueFormatter: numberFormatter(2),
                cellClass,
            },
            {
                field: 'reminder',
                headerName: 'Остаток по договору',
                width: 200,
                valueFormatter: numberFormatter(2),
                cellClass,
            },
            {
                field: 'cost',
                headerName: 'Перераспределение',
                width: 200,
                valueFormatter: numberFormatter(2),
                cellRenderer: CostCellRendererComponent,
                cellRendererParams: {
                    checkedIds,
                    onChange,
                },
                suppressKeyboardEvent: suppressKeyboardEventForInput,
                cellClass,
            },
        ],
        [allIds, changeCollapseState, checkedIds, collapseState, noCheckboxChecker, onChange, onCheckChange],
    );
};
